import React, { useState } from "react";
import "./bookmarkcard.css";

function BookmarkCard({ title, imageUrl, description, link, created }) {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = e.target.closest(".card").getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setCursorPosition({ x, y });
  };

  return (
    <>
      <div
        className="card w-96 bg-base-100 shadow-xl m-4 cardBookmakr"
        onMouseMove={handleMouseMove}
      >
        <a href={link} target="_blank" rel="noopener noreferrer">
          {imageUrl && (
            <figure>
              <img src={imageUrl} alt="Bookmark" />
            </figure>
          )}
        </a>
        <div className="card-body aiCardBody">
          {title && (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="card-title link link-hover"
            >
              {title}
            </a>
          )}
          <div className="text-gray-500 text-sm mb-2">
            Added on: {new Date(created).toLocaleDateString()}
          </div>
          {description ? (
            <p>{description}</p>
          ) : (
            <p className="text-gray-500">No description available.</p>
          )}
        </div>
        <div
          className="shimmer-circle"
          style={{ left: cursorPosition.x, top: cursorPosition.y }}
        />
      </div>
    </>
  );
}

export default BookmarkCard;